import { useQuery as useSearchSuggestionsEmptyStateQuery } from "@faire/web-api--source/endpoints/www/api/v3/layout/search/empty-page-suggestions/retailerToken/get-hooks";
import { keepPreviousData } from "@tanstack/react-query";

// 1 minute
const STALE_TIME = 1000 * 60;

export const useSDUISearchSuggestionsEmptyState = (retailerToken: string) => {
  const { data } = useSearchSuggestionsEmptyStateQuery(retailerToken, {
    staleTime: STALE_TIME,
    placeholderData: keepPreviousData,
  });

  return data;
};
